module.exports = __webpack_public_path__ + "img/Tutorial_Part2_NoVideo.7f3ba5b3.png";